export const TICKET_STATUS = {
  aperto: "Aperto",
  in_lavorazione: "In lavorazione",
  in_attesa_cliente: "In attesa del cliente",
  risolto: "Risolto",
  chiuso: "Chiuso",
};
export const STATUS_COLORS = {
  aperto: "#6FA8FF",
  in_lavorazione: "#E3BE4F",
  in_attesa_cliente: "#D59A6A",
  risolto: "#5DCB8A",
  chiuso: "#8F8A82",
};
export const OPEN_STATUSES = ["aperto", "in_lavorazione", "in_attesa_cliente"];
export const PRIORITY = { bassa: "Bassa", normale: "Normale", alta: "Alta", urgente: "Urgente" };
export const PRIORITY_COLORS = { bassa: "#8F8A82", normale: "#E8E2D4", alta: "#E3BE4F", urgente: "#F06A55" };
export const CENTER_STATUS = { pending: "In attesa", approved: "Attivo", rejected: "Non approvato", suspended: "Sospeso" };
export const CENTER_STATUS_COLORS = { pending: "#E3BE4F", approved: "#5DCB8A", rejected: "#F06A55", suspended: "#8F8A82" };
export const SECTIONS = { attestati: "Attestati", contratti: "Contratti", loghi: "Loghi", documenti: "Documenti" };
export const ORDER_STATUS = { inviato: "Inviato al commerciale", chiuso: "Confermato", annullato: "Annullato" };
export const fmtEur = (v) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v || 0);

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" }) : "—";
export const fmtShort = (s) => (s ? new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");
export const fmtDateTime = (s) =>
  s
    ? new Date(s).toLocaleString("it-IT", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "—";
export const hoursSince = (s) => (Date.now() - new Date(s).getTime()) / 36e5;
export const fmtElapsed = (h) => (h < 1 ? `${Math.max(1, Math.round(h * 60))} min` : h < 48 ? `${Math.floor(h)} h` : `${Math.floor(h / 24)} g`);
export const SLA_COLORS = { green: "#5DCB8A", yellow: "#E3BE4F", red: "#F06A55" };
export const slaTone = (h) => (h < 24 ? "green" : h < 48 ? "yellow" : "red");
export const isNew = (s) => hoursSince(s) < 24 * 30;
export const fileExt = (name = "") => (name.includes(".") ? name.split(".").pop().toUpperCase() : "FILE");
export const greeting = () => {
  const h = new Date().getHours();
  return h < 13 ? "Buongiorno" : h < 18 ? "Buon pomeriggio" : "Buonasera";
};
